import { useMemo } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import ColorDisplayAndPicker from "../../../components/common/ColorDisplayAndPicker";

export default function CustomNetWorthChartTooltip({
	active,
	payload,
	label,
	categoryKeys,
	periodType,
}) {
	const theme = useTheme();
	const { t } = useTranslation();
	const userCurrency = localStorage.getItem("userCurrency");

	const netWorthData = payload.find((entry) => entry.dataKey === "netWorth");
	const otherData = payload.filter(
		(entry) =>
			entry.dataKey !== "netWorth" &&
			entry.value !== 0 &&
			entry.value != null
	);
	const formattedLabel =
		periodType === "Monthly"
			? new Date(label).toLocaleDateString(undefined, {
					month: "long",
					year: "numeric",
				})
			: new Date(label).toLocaleDateString();

	const capitalizeFirstLetter = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	const translationMap = useMemo(
		() =>
			Object.fromEntries(
				categoryKeys.map(({ key, translationKey }) => [
					key,
					translationKey,
				])
			),
		[categoryKeys]
	);

	const tooltipBoxStyle = {
		background: theme.palette.background.paper,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: "12px",
		padding: "16px",
		boxShadow:
			theme.palette.mode === "dark"
				? "0 8px 32px rgba(0,0,0,0.4)"
				: "0 8px 32px rgba(0,0,0,0.15)",
		fontSize: "14px",
		minWidth: "200px",
	};
	if (!active || !payload) return null;

	return (
		<Box sx={tooltipBoxStyle}>
			<Box
				sx={{
					fontSize: "13px",
					color: theme.palette.text.secondary,
					fontWeight: 500,
				}}
			>
				{capitalizeFirstLetter(formattedLabel)}
			</Box>

			{netWorthData && (
				<Box
					sx={{
						marginBottom: "12px",
						paddingBottom: "8px",
						borderBottom: `1px solid ${theme.palette.divider}`,
					}}
				>
					<Box
						sx={{
							color: theme.palette.text.primary,
							fontWeight: 700,
							fontSize: "15px",
							display: "flex",
							justifyContent: "space-between",
						}}
					>
						<span>{t("nettWorth")}:</span>
						<span>
							{netWorthData.value.toFixed(2).toLocaleString()}{" "}
							{userCurrency}
						</span>
					</Box>
				</Box>
			)}

			{otherData.length > 0 && (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: "4px",
					}}
				>
					{otherData.map((entry, index) => (
						<Box
							key={index}
							sx={{
								display: "flex",
								justifyContent: "space-between",
								gap: "8px",
							}}
						>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<ColorDisplayAndPicker
									color={entry.color}
									isEditable={false}
								/>
								<span
									sx={{
										color: theme.palette.text.secondary,
										fontSize: "13px",
									}}
								>
									{t(translationMap[entry.dataKey])}:{" "}
								</span>
							</Box>
							<span>
								{" "}
								{entry.value.toFixed(2).toLocaleString()}{" "}
								{userCurrency}
							</span>
						</Box>
					))}
				</Box>
			)}
		</Box>
	);
}
